const URLs = {
  // Auth API's
  GET_LIST: 'posts'
}

export default URLs
